<template>
    <el-dialog
      title="发送邮件" 
      :visible.sync="dialogVisible"
      top="5vh"
      width="70%" 
      :before-close="handleClose">
      <el-form class="TicketMailSendDialogForm">
            <el-form-item label="工单">
                <el-input disabled v-model="ticketSubject"/>
            </el-form-item>
            <el-form-item label="邮件标题">
                <el-input v-model="mailSubject"/>
            </el-form-item>
            <el-form-item label="邮件内容(工单内容会自动作为邮件内容, 这里填写附加的其他内容)">
                <el-input v-model="mailContent" type="textarea"/>
            </el-form-item>
            <el-form-item label="收件人邮箱(你希望把邮件发送给谁, 可以英文分号分隔填入多个)">
                <el-input v-model="mailTo"/>
            </el-form-item>
            <el-form-item label="抄送(可以英文分号分隔填入多个)">
                <el-input v-model="mailCc"/>
            </el-form-item>
            <el-form-item label="回复到(当对方回复邮件时候, 你希望谁收到)">
                <el-input v-model="replyTo"/>
            </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button @click="doMailPreview">预览</el-button>
        <el-button type="primary" @click="doMailSend">发送</el-button>
      </span>
    </el-dialog>
</template>

<script>
export default {
  name: "TicketMailSendDialog",

  data() {
    return {
      dialogVisible: false,
      mailTo : '',
      mailCc : '',
      replyTo : '',
      ticketNo : '',
      ticketSubject : '',
      mailSubject : '',
      mailContent : ''
    };
  },

  methods: {
    show(_ticket) {
        var _this = this;

        _this.dialogVisible = true;

        sdk.TicketUserApi().currentUserCached().then(res => {
            if ( !!res ) {
                _this.replyTo = res.mail;
                _this.ticketNo = _ticket.orderId;
                _this.ticketSubject = _ticket.orderTitle;
                _this.mailSubject = _ticket.orderTitle;
                return;
            }

            console.log('#68 currentUserCached is null', res);
        });
    },

    doMailPreview() {
        window.open('/ticket/ticket_mail_preview?ticketNo=' + this.ticketNo + '&mailContent=' + this.mailContent);
    },

    //指派
    doMailSend() {
        var _this = this;

        sdk.TicketMailApi().sendMail({
            ticketNo : _this.ticketNo,
            mailTo : _this.mailTo,
            mailCc : _this.mailCc,
            replyTo : _this.replyTo, 
            mailSubject : _this.mailSubject, 
            mailContent : _this.mailContent
        }).then(res => {
            _this.dialogVisible = false;
            _message('邮件发送成功');
        });
    },

    //弹出层关闭-指派
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style>
.TicketMailSendDialogForm {
    padding:0 10px;
}
.TicketMailSendDialogForm .el-form-item {
    margin-bottom:0;
}
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketMailSendDialog.vue